// Hinweismeldung
const NoEntryMessage = ({ children }) => {
  return <div className="info-container">{children}</div>;
};

export default NoEntryMessage;
